import { CartAddEvent } from '@theme/events';

// Boisya - panier coulissant :
// 1. rafraichit le panier apres tout ajout fait hors du theme (ex. fiche produit Boisya, bundle)
// 2. ajout direct depuis l'upsell du panier.
if (!window.__bsyCart) {
  window.__bsyCart = true;

  // Le theme rouvre le panier a chaque mise a jour (option "ouverture auto"),
  // meme quand il est deja ouvert -> effet ferme / rouvre. On intercepte l'evenement
  // en premier (phase de capture) et, si le panier est deja ouvert, on desactive
  // l'ouverture auto le temps de cet evenement.
  window.addEventListener(
    'cart:update',
    () => {
      const drawer = document.querySelector('cart-drawer-component[auto-open]');
      const dialog = drawer ? drawer.querySelector('dialog') : null;
      if (!drawer || !dialog || !dialog.open) return;
      drawer.removeAttribute('auto-open');
      window.setTimeout(() => drawer.setAttribute('auto-open', ''), 0);
    },
    true
  );

  // Corbeille : le theme retire la ligne du DOM pendant le clic, et le panier
  // croit alors que l'on a clique "en dehors" -> il se ferme. On intercepte le clic
  // en premier et on lance la suppression juste apres, une fois le clic termine.
  window.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target ? target.closest('.cart-drawer .cart-items__remove') : null;
      if (!button) return;
      const component = button.closest('cart-items-component');
      const action = button.getAttribute('on:click') || '';
      const line = parseInt(action.split('/').pop(), 10);
      if (!component || !line || typeof component.onLineItemRemove !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.setTimeout(() => component.onLineItemRemove(line), 0);
    },
    true
  );

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);

  const refreshCart = async (source, variantId) => {
    const cartResponse = await nativeFetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    const cart = await cartResponse.json();
    document.dispatchEvent(
      new CartAddEvent({}, source, {
        source,
        itemCount: cart.item_count,
        variantId: variantId ? String(variantId) : undefined,
      })
    );
  };


  // Affichage instantane : des le clic sur "Ajouter au panier", on ouvre le panier
  // avec un squelette identique au vrai panier (meme structure, memes classes,
  // meme position du produit), puis le vrai panier le remplace sans saut visuel.
  const skelCss =
    '.bsy-sk{display:block;border-radius:2px;background:linear-gradient(90deg,#F0EBE3 0%,#E4DCD0 50%,#F0EBE3 100%);background-size:200% 100%;animation:bsy-sk 1.2s linear infinite}' +
    '@keyframes bsy-sk{to{background-position:-200% 0}}' +
    '.bsy-skel-qty{display:inline-flex;align-items:center;justify-content:space-between;padding:0 10px;width:92px;height:34px;border:1px solid #EDE8E0;font-size:13px;color:#2C2417;box-sizing:border-box}' +
    '.bsy-skel-busy{opacity:.45;transition:opacity .2s}' +
    '.bsy-skel-row .bsy-line__now{opacity:.6}';

  const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  const pageInfo = (button) => {
    const img = document.querySelector('.product-media-container img, .product-media img');
    const h1 = document.querySelector('h1');
    const picked = Array.from(document.querySelectorAll('variant-picker input[type="radio"]:checked')).map((i) => i.value);
    let price = '';
    if (button.classList.contains('bsy-batc')) {
      const parts = button.textContent.split('·');
      if (parts.length > 1) price = parts[parts.length - 1].trim();
    }
    if (!price) {
      const p = document.querySelector('product-price .price, .product-information .price, .price');
      price = p ? p.textContent.trim() : '';
    }
    const idInput = document.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return {
      img: img ? img.currentSrc || img.src : '',
      title: h1 ? h1.textContent.trim() : '',
      variant: picked.join(' · '),
      price,
      variantId: idInput ? String(idInput.value) : '',
    };
  };

  const rowHtml = (d) =>
    '<tr class="cart-items__table-row bsy-line bsy-skel-row" style="padding-bottom:12px;margin-bottom:12px">' +
    '<td class="cart-items__media"><span class="cart-items__media-container" style="--ratio: 1;">' +
    (d.img ? '<img class="cart-items__media-image" src="' + esc(d.img) + '" alt="">' : '<span class="bsy-sk" style="width:100%;aspect-ratio:1"></span>') +
    '</span></td>' +
    '<td class="bsy-line__info"><span class="bsy-line__title">' + esc(d.title) + '</span>' +
    (d.variant ? '<p class="bsy-line__variant">' + esc(d.variant) + '</p>' : '') + '</td>' +
    '<td class="bsy-line__price"><span class="bsy-line__now">' + esc(d.price) + '</span><span class="bsy-sk" style="width:64px;height:12px;margin-top:4px"></span></td>' +
    '<td class="bsy-line__qty cart-items__quantity"><span class="bsy-skel-qty"><span>−</span><span>1</span><span>+</span></span><span style="display:inline-block;width:34px;height:34px"></span></td>' +
    '</tr>';

  const logoHtml = () => {
    const logo = document.querySelector('.bsy-head__logo, .header-logo img, .header__logo img');
    return logo ? '<img class="bsy-head__logo" src="' + esc(logo.currentSrc || logo.src) + '" alt="">' : '';
  };

  const fullHtml = (d, closeHtml, bandHtml) =>
    '<div class="cart-drawer__header bsy-skel-full"><h2 class="cart-drawer__heading h4 bsy-head"><span class="visually-hidden">Votre panier</span>' + logoHtml() +
    '<div class="cart-bubble" data-maintain-ratio><span class="cart-bubble__background"></span><span class="cart-bubble__text"><span class="cart-bubble__text-count">1</span></span></div></h2>' +
    closeHtml + '</div>' +
    '<div class="cart-drawer__content" aria-label="Panier">' + bandHtml +
    '<div class="cart-drawer__items" style="padding-top:18px"><div class="cart-items__wrapper"><div class="cart-items cart-items--dividers" style="--cart-items-gap: 16px;"><table class="cart-items__table"><tbody>' +
    rowHtml(d) + '</tbody></table></div></div>' +
    '<div class="bsy-upsell-slot" data-bsy-upsell-slot></div></div>' +
    '<div class="cart-drawer__summary"><div class="bsy-summary">' +
    '<ul class="bsy-summary__lines" role="list"><li class="bsy-summary__line bsy-summary__line--muted"><span>Livraison</span><span>Offerte</span></li></ul>' +
    '<div class="bsy-summary__total"><span class="bsy-summary__total-label">Total</span><div class="bsy-summary__total-right"><span class="bsy-summary__total-value">' + esc(d.price) + '</span></div></div>' +
    '<div class="cart__ctas"><button type="button" class="cart__checkout-button button" data-bsy-skel-checkout><span class="button-text">Finaliser la commande</span></button><span class="bsy-sk" style="height:40px"></span></div>' +
    '</div></div></div>';

  let skelRestore = null;

  const clearPending = () => {
    document.querySelectorAll('.bsy-skel-row').forEach((el) => el.remove());
    document.querySelectorAll('.bsy-skel-busy').forEach((el) => el.classList.remove('bsy-skel-busy'));
    skelRestore = null;
  };

  const failPending = () => {
    if (skelRestore) skelRestore();
    clearPending();
  };

  const showPending = (button) => {
    try {
      const drawer = document.querySelector('cart-drawer-component');
      const items = drawer ? drawer.querySelector('cart-items-component') : null;
      if (!items || drawer.querySelector('.bsy-skel-row')) return;
      if (!document.getElementById('bsy-skel-css')) {
        const st = document.createElement('style');
        st.id = 'bsy-skel-css';
        st.textContent = skelCss;
        document.head.appendChild(st);
      }
      const d = pageInfo(button);
      const dialog = drawer.querySelector('dialog');
      const empty = items.querySelector('.bsy-empty');

      if (empty) {
        // Panier vide : on dessine le panier complet (en-tete, ligne, suggestions, total).
        const before = items.innerHTML;
        const wasEmptyClass = dialog && dialog.classList.contains('cart-drawer--empty');
        const close = items.querySelector('.cart-drawer__close-button');
        const band = items.querySelector('.bsy-band');
        items.innerHTML = fullHtml(d, close ? close.outerHTML : '', band ? band.outerHTML : '');
        if (dialog) dialog.classList.remove('cart-drawer--empty');
        skelRestore = () => {
          if (!items.querySelector('.bsy-skel-full')) return;
          items.innerHTML = before;
          if (dialog && wasEmptyClass) dialog.classList.add('cart-drawer--empty');
        };
      } else {
        // Panier deja rempli : meme variante -> on grise sa ligne ; sinon nouvelle ligne en haut,
        // la ou Shopify la placera.
        const tbody = items.querySelector('.cart-items__table tbody');
        const existing = d.variantId ? items.querySelector('.bsy-line[data-key^="' + d.variantId + ':"]') : null;
        if (existing) existing.classList.add('bsy-skel-busy');
        else if (tbody) tbody.insertAdjacentHTML('afterbegin', rowHtml(d));
        const total = items.querySelector('.bsy-summary__total-value');
        if (total) total.classList.add('bsy-skel-busy');
        const list = items.querySelector('.cart-drawer__items');
        if (list) list.scrollTop = 0;
      }

      if (typeof drawer.showDialog === 'function') drawer.showDialog();
      else if (typeof drawer.open === 'function') drawer.open();
      window.setTimeout(() => { if (skelRestore || document.querySelector('.bsy-skel-row')) failPending(); }, 10000);
    } catch (error) {
      console.error(error);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target
        ? target.closest('.bsy-batc, button.add-to-cart-button, product-form-component button[name="add"]')
        : null;
      if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
      if (button.closest('cart-drawer-component')) return;
      window.setTimeout(() => showPending(button), 0);
    },
    true
  );

  // "Finaliser" est cliquable tout de suite : si l'ajout est encore en cours,
  // on attend sa confirmation puis on part au paiement.
  let wantCheckout = false;
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target ? target.closest('[data-bsy-skel-checkout]') : null;
      if (!button) return;
      event.preventDefault();
      wantCheckout = true;
      button.setAttribute('aria-busy', 'true');
      button.style.opacity = '0.75';
    },
    true
  );

  // Le vrai panier remplace le squelette ; en cas d'erreur on remet l'etat d'avant.
  document.addEventListener('cart:update', () => {
    if (wantCheckout) {
      wantCheckout = false;
      window.location.href = root + 'checkout';
      return;
    }
    window.setTimeout(clearPending, 0);
  });
  document.addEventListener('cart:error', () => {
    wantCheckout = false;
    failPending();
  });

  window.fetch = async (...args) => {
    let [input, init] = args;
    let injected = false;
    let addedQty = 0;
    try {
      const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
      const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string' && !init.body.includes('sections')) {
        // Ajout externe (bundle, fiche Boisya) : on demande directement le HTML du panier
        // dans la meme requete, pour l'afficher sans second aller-retour serveur.
        const ids = Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map((el) => el.dataset.sectionId);
        const data = JSON.parse(init.body);
        if (ids.length && data && typeof data === 'object') {
          data.sections = ids.join(',');
          data.sections_url = window.location.pathname;
          const lines = Array.isArray(data.items) ? data.items : [{ quantity: data.quantity || 1 }];
          addedQty = lines.reduce((sum, line) => sum + (Number(line.quantity) || 1), 0);
          init = Object.assign({}, init, { body: JSON.stringify(data) });
          args = [input, init];
          injected = true;
        }
      }
    } catch (error) {
      injected = false;
    }

    const response = await nativeFetch(...args);
    try {
      const [input2, init2] = args;
      const url = typeof input2 === 'string' ? input2 : input2 instanceof URL ? input2.href : input2.url;
      const method = String((init2 && init2.method) || (input2 && input2.method) || 'GET').toUpperCase();
      if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url) && response.ok) {
        if (injected) {
          const json = await response.clone().json();
          document.dispatchEvent(
            new CartAddEvent({}, 'bsy-external-add', {
              source: 'product-form-component',
              itemCount: addedQty,
              sections: json && json.sections,
            })
          );
        } else {
          const body = init2 && init2.body;
          let hasSections = false;
          if (typeof body === 'string') hasSections = body.includes('sections');
          else if (body instanceof FormData) hasSections = body.has('sections');
          // Le theme renvoie deja les sections a jour : on ne rafraichit que les ajouts externes.
          if (!hasSections) refreshCart('bsy-external-add');
        }
      }
    } catch (error) {
      console.error(error);
    }
    return response;
  };

  // Apres un changement de quantite / suppression dans le panier : on met a jour
  // uniquement les blocs Boisya (paliers, suggestions, recapitulatif, prix) sans
  // reconstruire le panier, pour qu'il reste ouvert.
  const swap = (current, next) => {
    if (current && next) current.replaceWith(next);
    else if (current && !next) current.remove();
  };

  const patchDrawer = async (sectionId) => {
    const drawer = document.querySelector(`cart-items-component[data-section-id="${sectionId}"]`);
    if (!drawer) return;
    const response = await nativeFetch(`${root}?sections=${encodeURIComponent(sectionId)}`);
    const data = await response.json();
    const html = data && data[sectionId];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector(`cart-items-component[data-section-id="${sectionId}"]`) || doc;
    if (!next.querySelector('.bsy-line')) return; // panier vide : gere par le theme

    // Paliers : on change seulement les classes pour garder l'animation
    const tiers = drawer.querySelector('.bsy-tiers');
    const nextTiers = next.querySelector('.bsy-tiers');
    if (tiers && nextTiers) {
      const msg = tiers.querySelector('.bsy-tiers__msg');
      const nextMsg = nextTiers.querySelector('.bsy-tiers__msg');
      if (msg && nextMsg) msg.innerHTML = nextMsg.innerHTML;
      const segs = tiers.querySelectorAll('.bsy-tiers__seg, .bsy-tiers__labels span');
      const nextSegs = nextTiers.querySelectorAll('.bsy-tiers__seg, .bsy-tiers__labels span');
      segs.forEach((el, i) => { if (nextSegs[i]) el.className = nextSegs[i].className; });
    }

    // Prix de chaque ligne
    drawer.querySelectorAll('.bsy-line[data-key]').forEach((row) => {
      const nextRow = next.querySelector(`.bsy-line[data-key="${row.dataset.key}"]`);
      const price = row.querySelector('.bsy-line__price');
      const nextPrice = nextRow ? nextRow.querySelector('.bsy-line__price') : null;
      if (price && nextPrice) price.innerHTML = nextPrice.innerHTML;
    });

    // Recapitulatif (sans toucher aux boutons Apple Pay / PayPal)
    swap(drawer.querySelector('.bsy-summary__lines'), next.querySelector('.bsy-summary__lines'));
    swap(drawer.querySelector('.bsy-summary__total'), next.querySelector('.bsy-summary__total'));
  };

  document.addEventListener('cart:update', (event) => {
    const detail = event.detail || {};
    const source = detail.data && detail.data.source;
    if (source !== 'cart-items-component') return;
    const target = event.target instanceof Element ? event.target : null;
    const sectionId = (target && target.dataset && target.dataset.sectionId) || detail.sourceId;
    if (!sectionId) return;
    window.setTimeout(() => {
      patchDrawer(sectionId).catch((error) => console.error(error));
    }, 350);
  });

  // Suggestions "Souvent ajoute avec" : ordinateur uniquement, chargees apres
  // l'affichage du panier (total et bouton de paiement d'abord). Sur mobile,
  // rien n'est demande au serveur.
  const desktop = window.matchMedia('(min-width: 750px)');
  let upsellHtml = null;
  let upsellReq = null;
  let upsellStamp = '';

  const cartStamp = () =>
    Array.from(document.querySelectorAll('cart-drawer-component .bsy-line[data-key]'))
      .map((row) => row.dataset.key)
      .join('|');

  const fetchUpsell = () => {
    if (upsellReq) return upsellReq;
    upsellReq = nativeFetch(`${root}?section_id=boisya-cart-upsell`, { headers: { Accept: 'text/html' } })
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const block = doc.querySelector('.bsy-upsell');
        upsellHtml = block ? block.outerHTML : '';
        return upsellHtml;
      })
      .catch(() => '')
      .finally(() => {
        upsellReq = null;
      });
    return upsellReq;
  };

  const fillUpsell = async (force) => {
    if (!desktop.matches) return;
    const slot = document.querySelector('cart-drawer-component [data-bsy-upsell-slot]');
    if (!slot || !document.querySelector('cart-drawer-component .bsy-line[data-key]')) return;
    const stamp = cartStamp();
    if (!force && slot.firstElementChild && stamp === upsellStamp) return;
    const html = upsellHtml !== null && stamp === upsellStamp && !force ? upsellHtml : await fetchUpsell();
    upsellStamp = stamp;
    const live = document.querySelector('cart-drawer-component [data-bsy-upsell-slot]');
    if (live) live.innerHTML = html || '';
  };

  const scheduleUpsell = (force) => {
    if (!desktop.matches) return;
    const run = () => fillUpsell(force).catch((error) => console.error(error));
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 600 });
    else window.setTimeout(run, 120);
  };

  // A l'ouverture du panier
  const watchDialog = () => {
    const dialog = document.querySelector('cart-drawer-component dialog');
    if (!dialog) return;
    new MutationObserver(() => {
      if (dialog.open) scheduleUpsell(false);
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    if (dialog.open) scheduleUpsell(false);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDialog);
  else watchDialog();

  // Apres chaque mise a jour du panier (ajout, quantite, suppression)
  document.addEventListener('cart:update', () => {
    // On remet tout de suite la derniere version (pas de clignotement), puis on rafraichit.
    window.setTimeout(() => {
      const slot = document.querySelector('cart-drawer-component [data-bsy-upsell-slot]');
      if (desktop.matches && slot && !slot.firstElementChild && upsellHtml) slot.innerHTML = upsellHtml;
    }, 60);
    window.setTimeout(() => scheduleUpsell(true), 400);
  });
  desktop.addEventListener('change', () => scheduleUpsell(false));

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target ? target.closest('[data-bsy-add]') : null;
    if (!button) return;

    event.preventDefault();
    const item = button.closest('.bsy-upsell__item');
    const select = item ? item.querySelector('[data-bsy-variant-select]') : null;
    const variantId = Number((select && select.value) || button.getAttribute('data-bsy-add'));
    if (!variantId) return;

    button.setAttribute('aria-busy', 'true');

    try {
      const addResponse = await nativeFetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!addResponse.ok) throw new Error('add failed');
      await refreshCart('bsy-upsell', variantId);
    } catch (error) {
      console.error(error);
      button.removeAttribute('aria-busy');
    }
  });
}
